import React from 'react';
import { FeaturePlaceholder } from '@/components/ui';

interface PlaceholderTabProps {
  title: string;
}

export function PlaceholderTab({ title }: PlaceholderTabProps) {
  return (
    <FeaturePlaceholder
      title={title}
      description="Dữ liệu đang được liên kết từ các phân hệ BOQ, Quản lý tài liệu và Kế toán thi công."
    />
  );
}
